import { withInstall, withNoopInstall } from '@jdesign-vue/utils'

import Breadcrumb from './src/breadcrumb.vue'
import BreadcrumbItem from './src/breadcrumb-item.vue'

export const JdBreadcrumb = withInstall(Breadcrumb, {
  BreadcrumbItem,
})
export const JdBreadcrumbItem = withNoopInstall(BreadcrumbItem)
export default JdBreadcrumb

export * from './src/breadcrumb'
export * from './src/breadcrumb-item'
export * from './src/constants'
export type {
  BreadcrumbInstance,
  BreadcrumbItemInstance,
} from './src/instances'
